export const environment = {
  production: false,
  apiUrl: 'https://dev.todosector.com/api',
};
